import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import TreeDetailsPage from './pages/TreeDetailsPage';
import UserStatsPage from './pages/UserStatsPage';
import HomePage from './pages/HomePage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Private Routes - Grouped inside the PrivateRoute wrapper */}
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/tree/:id" element={<TreeDetailsPage />} />
            <Route path="/stats" element={<UserStatsPage />} />
          </Route>
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;